import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=7c44f1ac&scoped=true"
var script = {}
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=7c44f1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c44f1ac",
  null
  
)

export default component.exports